export const PRODUCT_CATEGORIES = [
    "Necklace",
    "Bracelet",
    "Earings",
    "Keychains/Phone charms",
    "Watches",
    "Plushies",
    "Sets",
]
